import React, {useEffect, useState} from 'react';
import {Table, Button, Modal, Input, Form } from 'antd';
import 'antd/dist/antd.css';
import '../App.css';

import axios from 'axios';

const {Item} = Form;

const Crud = () => {

    const [data, setData] = useState([]);
    const [modalInsertar, setModalInsertar] = useState(false);
    const [modalEditar, setModalEditar] = useState(false);    
    const [modalEliminar, setModalEliminar] = useState(false);    

    const [artista, setArtista] = useState({
        id:"",
        artista:"",
        pais:"",
        periodo:""
    })

    const abrirCerrarModalInsertar=()=>{
        setModalInsertar(!modalInsertar);
    }

    const abrirCerrarModalEditar=()=>{
        setModalEditar(!modalEditar);
    }

    const abrirCerrarModalEliminar=()=>{
        setModalEliminar(!modalEliminar);
    }



    const handleChange=e=>{
        const {name, value}=e.target;
        setArtista({...artista, [name]: value});
        console.log(artista)
    }


    const seleccionarArtista=(artista,caso)=>{
        console.log("artista seleccionado");
        console.log(artista);
        setArtista(artista);
        (caso ==="Editar")? abrirCerrarModalEditar():abrirCerrarModalEliminar();
    }


    const baseUrl = "http://localhost:3001/artistas";

    const columns= [
        {
            title: "ID",
            dataIndex:"id",
            key:"id"
        },
        {
            title: "Artista",
            dataIndex:"artista",
            key:"artista"
        },
        {
            title: "Pais",
            dataIndex:"pais",
            key:"pais"
        },
        {
            title: "Periodo de actividad",
            dataIndex:"periodo",
            key:"periodo"
        },
        {
            title: "Acciones",
            key:"acciones",
            render: fila => (
                <>
                    <Button type="primary" onClick={()=>seleccionarArtista(fila, "Editar")} >Editar</Button> {"   "} 
                    <Button type="primary" danger onClick={()=>seleccionarArtista(fila, "Eliminar")} >Eliminar</Button>
                </>
            ),
        },                                
    ];

    //GET - OBTENER DATOS
    //aca creamos la peticion asyncrona (se ejecuta en segundo plano), la peticion es para traer la data de un WebService, que es un json que esta en una URL
    //y una vez que se obtuvo una respuesta positiva, se guarda en el hook data mediante el setData, y si la respuesta es negativa, tira el error por consola

    const peticionGet = async() => {
        await axios.get(baseUrl)
        .then(response=>{
            setData(response.data);
        }).catch(error=>{
            console.log(error);
        })
    }


    //POST - INSERTAR
    const peticionPost = async() => {
        delete artista.id;
        await axios.post(baseUrl,artista)
        .then(response=>{
            setData(data.concat(response.data));
            abrirCerrarModalInsertar();
        }).catch(error=>{
            console.log(error);
        })
    }    

    //PUT - EDITAR - Aqui se recorre hasta el artista id indicado y se modifican los campos
    const peticionPut = async() => {
        await axios.put(baseUrl+"/"+artista.id,artista)
        .then(response=>{
            var dataAuxiliar = data;
            dataAuxiliar.map(elemento =>{

                console.log("ENTRO EN MAP");
                console.log("elemento.id");
                console.log(elemento.id);
                console.log("artista.id")
                console.log(artista.id)

                if(elemento.id===artista.id){
                    elemento.artista=artista.artista;
                    elemento.pais=artista.pais;
                    elemento.periodo=artista.periodo;
                }
            });

            setData(dataAuxiliar);
            abrirCerrarModalEditar();
        }).catch(error=>{
            console.log(error);
        })
    }

        //DELETE - Eliminar
        const peticionDelete = async() => {
            await axios.delete(baseUrl+"/"+artista.id)
            .then(response=>{                          
                setData(data.filter(elemento=>elemento.id!==artista.id));
                abrirCerrarModalEliminar();
            }).catch(error=>{
                console.log(error);
            })
        }



    //Aca llamamos a la funcion peticion con useEffect

    useEffect(()=>{
        peticionGet();        
    },[])


    const layout = {
        labelCol: {
          span: 8,
        },
        wrapperCol: {
          span: 16,
        },
      };

    return (
        <div>
            
            {/*BOTON INSERTAR*/}
            <br/><br/>
            <div style={{width:"100%", marginTop: "30px"}} >                        
              <div style={{margin: "0 auto", width:"200px"}}>
                <Button onClick={abrirCerrarModalInsertar} style={{ marginLeft: 8 , marginTop: 8, backgroundColor:"#4caf50", bordercolor: "#4caf50" }} type="primary" className="botonInsertar">Insertar nuevo artista</Button>
               </div>
            </div>
            <br/><br/>

            {/*TABLA*/}
            <Table columns={columns} dataSource={data} />

            {/*MODAL - INSERTAR*/}
            <Modal
            visible={modalInsertar}
            title="insertar Artista"
            destroyOnClose={true}
            onCancel={abrirCerrarModalInsertar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalInsertar}>Cancelar</Button>,
                    <Button onClick={peticionPost} type="primary">Insertar</Button>
                ]}
            >

                <Form {...layout}>
                    <Item label="Artista">
                        <Input name="artista" onChange={handleChange} ></Input>
                    </Item>

                    <Item label="Pais">
                        <Input name="pais" onChange={handleChange} ></Input>
                    </Item>

                    <Item label="Periodo de Actividad">
                        <Input name="periodo"onChange={handleChange}  ></Input>
                    </Item>                    
                </Form>

            </Modal>


            {/*MODAL - UPDATE*/}
            <Modal
            visible={modalEditar}
            title="Editar Artista"
            onCancel={abrirCerrarModalEditar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalEditar}>Cancelar</Button>,
                    <Button type="primary" onClick={peticionPut}>Editar</Button>
                ]}
            >

                <Form {...layout}>
                    <Item label="Artista">
                        <Input name="artista" onChange={handleChange} value={artista && artista.artista}></Input>
                    </Item>

                    <Item label="Pais">
                        <Input name="pais" onChange={handleChange}  value={artista && artista.pais}></Input>
                    </Item>

                    <Item label="Periodo de Actividad">
                        <Input name="periodo"onChange={handleChange}  value={artista && artista.periodo} ></Input>
                    </Item>                    
                </Form>

            </Modal>

            {/*MODAL - ELIMINAR*/}
            <Modal
            visible={modalEliminar}
            onCancel={abrirCerrarModalEliminar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalEliminar}>No</Button>,
                    <Button type="primary" danger onClick={peticionDelete}>Si</Button>
                ]}
            >

                Estas seguro que deseas eliminar al artista <b>{artista && artista.artista}</b>?

            </Modal>

            


        </div>
    )
}

export default Crud
